"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureContactEmailEnabled = isFeatureContactEmailEnabled;
function isFeatureContactEmailEnabled(companyId) {
    const companyIdsWithContactEmailEnabled = [719, 780];
    return companyIdsWithContactEmailEnabled.includes(companyId);
}
